import React from 'react';
import { I18nUtils } from '../../../i18n/I18nUtils';
import PropTypes from 'prop-types';

/**
 * Es posible que se quiera indicar una opción seleccionada sin que haya opciones. Por ejemplo, si dicha opción viene
 * dada por la edición de otro campo. En estos casos es necesario que se provea de una lista de opciones que contenga
 * mínimo dicha opción seleccionada, sino no llegará a renderizarse correctamente.
 */

export class FormSelect extends React.Component {

    render() {
        const {
            col,
            testId,
            disabled,
            label,
            options,
            displayEmptyOption,
            input: {
                value,
            },
            meta: {
                touched,
                error,
            },
            onChange,
        } = this.props;

        const option = value ? value[0] : undefined;
        const optionValue = option ? String(option.value) : '0';
        const noOptions = options.length === 0;
        const hasOption = !!option;

        return (
            <div className={col}>
                <div className="form-group">
                    {
                        label ? (
                            <label>{label}</label>
                        ) : null
                    }
                    <select
                        test-id={testId}
                        className="form-control show-tick bootstrap-select"
                        disabled={disabled || false}
                        onChange={onChange || this.handleChange}
                        value={optionValue}
                    >
                        {
                            // Solución para mostrar la opción en los casos que venga dada pero el listado
                            // de opciones donde se encuentra esté vacío.
                            noOptions && hasOption ? (
                                <option
                                    key={optionValue}
                                    value={optionValue}
                                    children={option.label || option.name}
                                    disabled={option.disabled}
                                />
                            ) : null
                        }
                        {
                            displayEmptyOption ? (
                                <option
                                    key={'0'}
                                    value={'0'}
                                    children={I18nUtils.tr('TR_ELIGE_UNA_OPCION')}
                                />
                            ) : null
                        }
                        {
                            options.map(
                                (opt) => (
                                    <option
                                        key={opt.value}
                                        value={opt.value}
                                        children={opt.label || opt.name}
                                        disabled={opt.disabled}
                                    />
                                ),
                            )
                        }
                    </select>
                    <label className="error">
                        {
                            touched && error ? error : ''
                        }
                    </label>
                </div>
            </div>
        );
    }

    handleChange = (event) => {
        const { input, options, onSet } = this.props;
        const valueSelected = options.filter((op) => String(op.value) === String(event.target.value))[0];
        const valueArray = valueSelected ? [valueSelected] : [];
        input.onChange(valueArray);
        onSet && onSet(valueArray); // Para casos que haya que modificar más de un campo
    };
}

FormSelect.propTypes = {
    displayEmptyOption: PropTypes.bool,
};

FormSelect.defaultProps = {
    displayEmptyOption: true,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/FormSelect.jsx